import { FC, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { resetPassword } from '@utils/Auth0Utils';
import { PageContent } from '@components/index';
import strings from '@strings/LocalisedStrings';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import { Avatar, Divider, Typography } from '@mui/material';
import { stringAvatar } from '@src/app/utils/StringUtils';
import { AssignmentIndOutlined } from '@mui/icons-material';

const Profile: FC = (): JSX.Element => {
  const { user, isLoading } = useAuth0<{
    email: string;
    name: string;
    // eslint-disable-next-line camelcase
    given_name: string;
    // eslint-disable-next-line camelcase
    family_name: string;
  }>();

  const [changePasswordLoading, setChangePasswordLoading] = useState(false);
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);

  const handleModalOpen = () => {
    setChangePasswordModalOpen(true);
  };
  const handleModalClose = () => {
    setChangePasswordModalOpen(false);
  };

  const handleChangePasswordPressed = async (email: string) => {
    setChangePasswordLoading(true);
    await resetPassword(email);
    handleModalOpen();
    setChangePasswordLoading(false);
  };

  const ChangePasswordButton: FC = (): JSX.Element => {
    if (!isLoading && user && user.email && !changePasswordLoading) {
      return (
        <Button sx={{ backgroundColor: '#F2FAF8', padding: '8px' }} onClick={() => handleChangePasswordPressed(user.email)}>
          {strings.changePassword}
        </Button>
      );
    }
    return (
      <LoadingButton loading sx={{ backgroundColor: '#F2FAF8', padding: '8px' }}>
        <span>{strings.changePassword}</span>
      </LoadingButton>
    );
  };

  return (
    <Container maxWidth={false}>
      <Box display="flex" flexDirection="column" gap="24px" mb={6}>
        <Box display="flex" gap="8px" alignItems="center">
          <AssignmentIndOutlined fontSize="large" />
          <Typography fontWeight={600} fontSize="30px">
            Profile
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="sm">
        <PageContent>
          <Grid container direction="column" spacing={2} justifyContent="center">
            <Grid item alignSelf="center">
              <Avatar {...stringAvatar(user?.name ?? '')} />
            </Grid>
            <Grid item alignSelf="center">
              <Typography fontWeight={600} fontSize="20px">
                {user?.given_name} {user?.family_name}
              </Typography>
            </Grid>
            <Grid item container spacing={1} alignItems="center" justifyContent="center">
              <Grid item mt={1}>
                <MailOutlineOutlinedIcon fontSize="small" sx={{ color: '#646464' }} />
              </Grid>
              <Grid item>
                <Typography>{user?.email}</Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Divider />
            </Grid>
            <Grid item>
              <ChangePasswordButton />
            </Grid>
          </Grid>
        </PageContent>
      </Container>

      <Dialog
        open={changePasswordModalOpen}
        onClose={handleModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{strings.changePasswordModalTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{strings.changePasswordModalMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} autoFocus>
            {strings.ok}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Profile;
